export abstract class AxMain {
    abstract readonly providers: any;
    abstract readonly declarations: any;
    abstract readonly utility: any;

    constructor() {
        this.Init();
    }

    Init() {
        if (typeof (this.providers) != 'undefined') {
            this.exportProviders();
        }
        if (typeof (this.declarations) != 'undefined') {
            this.exportDeclarations();
        }
        if (typeof (this.utility) != 'undefined') {
            this.exportUtility();
        }
    }

    exportDeclarations() {
        for (let i: number = 0; i < this.providers.length; i++) {
            const prov = this.providers[i];
            prov.availableProviders = [];

            if (prov.hasOwnProperty('availableProviders')) {
                for (let j = 0; j < this.declarations.length; j++) {
                    const currentDec = this.declarations[j];
                    const name = this.getModuleName(currentDec);
                    prov.availableProviders[name] = currentDec;
                }
            }
        }
    }

    exportProviders(): void {
        this.exportDependencies(this.providers);
    }

    exportUtility() {
        let dep = this.utility;
        this.exportDependencies(dep);

        for (let i: number = 0; i < dep.length; i++) {
            const utilMod = dep[i];

            if (typeof utilMod.prototype.AxInit != 'undefined') {
                $(document).ready(() => {
                    //let module = Object.create(utilMod.prototype);
                    //module.constructor();
                    let module = new utilMod;
                    module.AxInit();
                });
            }
        }
    }

    exportDependencies(dep: any[]) {
        for (let i: number = 0; i < dep.length; i++) {
            const name = this.getModuleName(dep[i]);
            window[name] = dep[i];
        }
    }

    getModuleName(dep: any) {
        let tmpName = dep.name;

        if (typeof dep.prototype.moduleAliasName != 'undefined' && dep.prototype.moduleAliasName != '') {
            tmpName = dep.prototype.moduleAliasName;
        }
        const name = tmpName;
        return name;
    }
}
